/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ModuloForm from './ModuloModalForm';
import * as validations from '../../validations/validations';
import * as moduloActions from '../../actions/moduloActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';
 
import * as tagActions from '../../actions/tagActions';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

import * as infoActions from '../../actions/infoActions';


class ManageModuloModalForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            test:0,
            actual: new moment().format('DD/MM/YYYY'),
			modulo1:{
                idsTags:[],
                fecha2: new moment().format('DD/MM/YYYY'),
                fechaInicio: new moment().format('DD/MM/YYYY'),
                fechaFin: new moment().format('DD/MM/YYYY')
                    }
		
	}
    
    }
    
    
    fechas=(fechasArreglo, fechasCadena)=>{
            
       
        
        let modulo1 = this.state.modulo1;
       
      
        
        if(fechasArreglo==null){
            modulo1.fechaInicio = null;
        }else{
            
            modulo1.fechaInicio = fechasCadena;
            modulo1.fechaInicioJS = fechasArreglo;
           
        }    
         this.setState({modulo1:modulo1});
    }
    
    
    fechas2=(fechasArreglo, fechasCadena)=>{
        let modulo1 = this.state.modulo1;
        if(fechasArreglo==null){
            modulo1.fechaFin = null;
        }else{
            modulo1.fechaFin = fechasCadena;  
            modulo1.fechaFinJS = fechasArreglo;  
        }
         this.setState({modulo1:modulo1});
    }
    
    
    componentDidMount(){
        
         usuarioActual(this, "modulo",true).then( (usuario)=>{
           let id=this.props.idModulo;
           let idCurso = this.props.idCurso;     
        
                this.props.tagActions.getTagCombo(usuario).then( ()=>{ 
           
               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 

             
             
                this.props.usuarioActions.getUsuarioCombo(14,usuario).then( ()=>{ 

               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 
             
        
             
            if(id && id>0 ){
                
                    this.props.moduloActions.getModuloConfig(id, idCurso, usuario).then( modulo1=>{
                       
                       this.setState({"modulo1":modulo1});
             
               })
                .catch(error=>{
                  toastr.error(error);
                }); 






            }


           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        


    handleChange=(event, data)=> {

        let modulo1 = this.state.modulo1;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		modulo1[field[0]]= value;
		else{
             if(!modulo1[field[0]]){
                    modulo1[field[0]]={}
                }
			modulo1[field[0]][field[1]]= value;
		}
        
		
        this.setState({"modulo1": modulo1});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let modulo1=this.state.modulo1;
              
        if(!validations.requerido(modulo1.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(modulo1.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        /*
        if(!validations.requerido(modulo1.imagen)){
            errors.imagen=true;
            formIsValid=false;
        }
        */
       
        if(!validations.requerido(modulo1.idsTags)){
            errors.idsTags=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        let newState=Object.assign({}, this.state.modulo1);
        
    
        
        newState.idCurso = this.props.idCurso;
        
        newState.fechaInicio = dayjs(this.state.modulo1.fechaInicioJS).format('DD/MM/YYYY');
        newState.fechaFin    = dayjs(this.state.modulo1.fechaFinJS).format('DD/MM/YYYY');
        
        newState.idsContenidos=[];
        
        
        this.props.moduloActions.saveConfig(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.cargarModulos(this.props.idCurso);
            this.props.closeModal();
            
        });
        
    }
    
    close=()=>{
        
         this.props.closeModal();
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
                <ModuloForm 
                    user={this.props.user}
                    infoActions={this.props.contenidoActions}
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.modulo1}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
            

                    tagCombo={genericFormattedForDropdown(this.props.tagCombo)}
                    contenidoCombo={genericFormattedForDropdown(this.props.contenidoCombo)}
                    contenidoComboTipo={this.props.contenidoCombo}
                    comboInstructor={genericFormattedForDropdown(this.props.usuarioCombo)}
                   
                    fechas={this.fechas}
                    fechas2={this.fechas2}
                    onBuscar={this.onBuscar}
                    goBack={this.goBack}
                    test={this.state.test}
                    close={this.close}
                
                />

		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            tagCombo:state.tagCombo,
            strings:state.strings,
    }

}

function mapDispatchToProps(dispatch){

	return {
        infoActions: bindActionCreators(infoActions, dispatch),
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        moduloActions: bindActionCreators(moduloActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageModuloModalForm);